import type {
  CostOverview,
  ShowCostOverviewInput,
} from '@snap-types/actions/show-cost-overview';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSiteUrl, param } from '@ui/store/api-builder/build-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

export const [showCostOverview, useShowCostOverviewQuery] = injectQuery<
  ShowCostOverviewInput,
  CostOverview
>(`${QUOTE_BUILDER_SLICE_NAME}/showCostOverview`, ({ siteCode, partId }) => ({
  url: buildSiteUrl(
    siteCode,
    `part-engineering/cost-overview/${param(partId)}`,
  ),
}));
